import { render, staticRenderFns } from "./CandidateJobs.vue?vue&type=template&id=0a7a5a43&scoped=true&"
import script from "./CandidateJobs.vue?vue&type=script&lang=ts&"
export * from "./CandidateJobs.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateJobs.vue?vue&type=style&index=0&id=0a7a5a43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7a5a43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VPagination,VRow,VSkeletonLoader})
